<template>
  <div class="smart-input-wrapper">
    <van-field
      v-model="inputValue"
      label=""
      :placeholder="placeholder"
      @input="onInputChange($event)"
      @focus="onFocus($event)"
      @blur="onBlur"
      ref="input"
      type="text"
      :readonly="readonly"
      :required="required"
      :maxlength="maxlength"
    />
  </div>
</template>

<style>
  .img-icon {
    height: 20px;
  }
</style>

<script>
import {
  Field,
  RadioGroup,
  Uploader,
  Radio,
  Switch,
  Picker,
  Popup,
  Toast,
  Calendar,
  Cell
} from 'vant'
import $ from 'jquery'
import moment from 'moment'

import {
  isObject,
  isArr
} from '@utils/basicUtil'
import UploadService from '@services/UploadService'

export default {
  name: 'smartInputField',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    icon: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number
    },
    options: {
      type: Array
    },
    fileList: {
      type: Array
    }
  },
  data () {
    return {
      inputValue: this.value,
      functionPoint: 'mobilecompany',
      calendarShow: false,
      showPicker: false
    }
  },
  watch: {
    value (newValue) {
      this.inputValue = newValue
    }
  },
  mounted () {
    window.$ = $
  },
  methods: {
    onInputChange: function ($event) {
      this.$emit('oninputchange', $event)
    },
    onFocus: function (e) {
      this.$emit('onFocus', e)
      const inputHeight = e.currentTarget.offsetParent.offsetParent.offsetParent.offsetHeight
      const currentPositionY = this.getTop(e.currentTarget)
      setTimeout(() => {
        const bodyClientHeight = document.body.clientHeight
        const res = currentPositionY - bodyClientHeight + inputHeight + 50
        try {
          if (res > 0) {
            this.$emit('onscroll', res)
          }
        } catch (e) {
        }
      }, 500)
    },
    getTop: function (e) {
      var offset = e.offsetTop
      if (e.offsetParent != null) offset += this.getTop(e.offsetParent)
      return offset
    },
    onBlur () {
      this.$emit('onBlur')
    },
    beforeRead (file) {
      if (isObject(file)) {
        if (
          file.type === 'image/jpeg' ||
          file.type === 'image/png'
        ) {
          return true
        } else {
          Toast('请上传 jpg/png/jpeg 格式图片')
          return false
        }
      } else if (isArr(file)) {
        if (file.every(item => item.type === 'image/jpeg' || item.type === 'image/png')) {
          return true
        } else {
          Toast('请上传 jpg/png/jpeg 格式图片')
          return false
        }
      }
    },
    afterRead (file) {
      file.status = 'uploading'
      file.message = '上传中...'
      UploadService(file.file, this.functionPoint).then(data => {
        if (data.code === '200') {
          this.$emit('finishUpload', data)
        } else {
          file.status = 'failed'
          file.message = data.message
          this.$emit('finishUpload', {
            success: false,
            ...data
          })
        }
        this.fileListInside = []
      }).catch(e => {
        this.fileListInside = []
        file.status = 'failed'
        file.message = e
        this.$props.finishUpload && this.$props.finishUpload({ success: false, ...e })
      })
    },
    beforeDelete (file) {
      this.$emit('beforeDelete', file)
    },
    onConfirmDate (date) {
      this.calendarShow = false
      this.onInputChange(moment(date).format('YYYY-MM-DD'))
    },
    onConfirmSelect (option, index) {
      this.showPicker = false
      this.inputValue = this.options[index].title
      this.onInputChange(this.options[index].value)
    }
  },
  components: {
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Uploader.name]: Uploader,
    [Calendar.name]: Calendar,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Picker.name]: Picker,
    [Popup.name]: Popup

  }
}
</script>

<style lang="less" scoped src="./style.less"/>
